import WebApplicationsCounter from "../../../../content/blog/web-applications/components/WebApplicationsCounter.js";
import WebApplicationsList from "../../../../content/blog/web-applications/components/WebApplicationsList.js";
import * as React from 'react';
export default {
  WebApplicationsCounter,
  WebApplicationsList,
  React
};